module.exports = __webpack_public_path__ + "48199e76a84d6283d1bf81a3eae2f4ec.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sega-footer-logo-lg.png
// module id = 527
// module chunks = 0